// SEO helpers: builds titles, descriptions and JSON-LD structured data.

export const SITE_NAME = 'Comfort Air Mechanical';

const origin = () => (typeof window !== 'undefined' ? window.location.origin : '');

export const telephoneIntl = (raw) => {
  // '19705657893' -> '+19705657893'
  if (!raw) return '';
  return raw.startsWith('+') ? raw : `+${raw}`;
};

// Core HVACBusiness / LocalBusiness structured data.
export const businessLd = (s, { image, areaServed } = {}) => {
  const [city, region, postal] = (s.city || 'Cortez, CO 81321').split(/,\s*|\s+(?=\d)/);
  const ld = {
    '@context': 'https://schema.org',
    '@type': 'HVACBusiness',
    '@id': `${origin()}/#business`,
    name: s.companyFull || SITE_NAME,
    alternateName: s.companyName,
    description:
      'Comfort Air Mechanical is a licensed HVAC contractor providing heating, air conditioning, refrigeration and sheet metal services across Cortez and the Four Corners area of Southwest Colorado since 1988.',
    url: origin() + '/',
    telephone: telephoneIntl(s.phoneRaw),
    email: s.email,
    image: image || `${origin()}/logo.png`,
    logo: `${origin()}/logo.png`,
    priceRange: '$$',
    foundingDate: '1988',
    address: {
      '@type': 'PostalAddress',
      streetAddress: s.address || '2421 E. Empire St.',
      addressLocality: 'Cortez',
      addressRegion: 'CO',
      postalCode: '81321',
      addressCountry: 'US'
    },
    geo: { '@type': 'GeoCoordinates', latitude: 37.3489, longitude: -108.5859 },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '17:00'
      }
    ],
    slogan: s.tagline
  };
  if (areaServed && areaServed.length) {
    ld.areaServed = areaServed.map((a) => ({
      '@type': a.state ? 'City' : 'AdministrativeArea',
      name: a.state ? `${a.city}, ${a.state}` : a.city
    }));
  }
  return ld;
};

export const breadcrumbLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: origin() + it.path
  }))
});

export const serviceLd = (name, description, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: name,
  name,
  description,
  provider: { '@type': 'HVACBusiness', name: SITE_NAME, '@id': `${origin()}/#business` },
  areaServed: { '@type': 'AdministrativeArea', name: 'Four Corners, Southwest Colorado' },
  url: origin() + path
});

export const faqLd = (faqs = []) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a }
  }))
});
